import { createContext, useContext, useState, useCallback, useRef, useEffect } from 'react';
import Icon from './Icon.jsx';

const Ctx = createContext(() => {});
export const useToast = () => useContext(Ctx);

let seq = 0;

export function ToastProvider({ children }) {
  const [items, setItems] = useState([]);
  const timers = useRef(new Map());
  const dismiss = useCallback(id => {
    clearTimeout(timers.current.get(id)); timers.current.delete(id);
    setItems(t => t.filter(x => x.id !== id));
  }, []);
  useEffect(() => () => { for (const timer of timers.current.values()) clearTimeout(timer); }, []);

  /** `action` ({ label, run }) adds one button, such as Undo, to the toast. */
  const push = useCallback((message, kind, action) => {
    const id = ++seq;
    setItems(t => [...t.filter(x => x.message !== message), { id, message, kind, action }].slice(-3));
    if (kind !== 'bad') timers.current.set(id, setTimeout(() => dismiss(id), action ? 8000 : 3800));
  }, [dismiss]);

  return (
    <Ctx.Provider value={push}>
      {children}
      <ToastList items={items} dismiss={dismiss} />
    </Ctx.Provider>
  );
}

function ToastList({ items, dismiss }) {
  if (!items.length) return null;
  return (
    <div className="toasts" aria-live="polite">
      {items.map(t => (
        <div key={t.id} role={t.kind === 'bad' ? 'alert' : 'status'} className={'toast' + (t.kind ? ' ' + t.kind : '')}><span>{t.message}</span>{t.action && <button className="toast-action" onClick={() => { dismiss(t.id); t.action.run(); }}>{t.action.label}</button>}<button aria-label="Dismiss notification" onClick={() => dismiss(t.id)}><Icon name="close" size={12} /></button></div>
      ))}
    </div>
  );
}

/** Rendered by App so the provider's list has a home even before any toast. */
export function Toasts() { return null; }
